import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import LearningEmployees from "../../../components/hrm/training/learn-analytics/LearningEmployees";
import CertificationCompleted from "../../../components/hrm/training/learn-analytics/CertificationCompleted";
import HighlyEnrolledCourses from "../../../components/hrm/training/learn-analytics/HighlyEnrolledCourses";
import LearningAnalyticsHeader from "../../../components/hrm/training/learn-analytics/LearningAnalyticsHeader";
import LearningEmployeeList from "../../../components/hrm/training/learn-analytics/LearningEmployeeList";
// import LearningEmployees from "./LearningEmployees";
// import CertificationCompleted from "./CertificationCompleted";
// import HighlyEnrolledCourses from "./HighlyEnrolledCourses";

export default function LearningAnalyticsPage() {
  const [filter, setFilter] = useState("Year");

  return (
    <div  style={{ padding: "15px", background: "#f8f9fa", fontFamily: "Inter, sans-serif" }} >
     <LearningAnalyticsHeader/>
      <Row>
        <Col lg={4} md={12}>
          <LearningEmployees filter={filter} setFilter={setFilter} />
        </Col>

        <Col lg={4} md={12} >
          <CertificationCompleted />
        </Col>

        <Col lg={4} md={12} >
          <HighlyEnrolledCourses filter={filter} setFilter={setFilter} />
        </Col>
      </Row>
<LearningEmployeeList  className="mt-2" />
      <style>
          {
               `
               const cardStyle = {
  padding: 20,
  borderRadius: 12,
  border: "1px solid #eee",
  background: "#fff",
};

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const dropdownStyle = {
  background: "#fff",
  border: "1px solid #ddd",
  color: "#111",
  fontSize: 13,
};

const iconBox = {
  width: 40,
  height: 40,
  borderRadius: "50%",
  background: "#fff7ed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto",
  color: "#f97316",
};

const badgeStyle = {
  background: "#dcfce7",
  color: "#16a34a",
  display: "inline-block",
  padding: "3px 8px",
  borderRadius: 20,
  fontSize: 12,
};

const barBg = {
  width: "100%",
  height: 8,
  background: "#f3f4f6",
  borderRadius: 6,
};

const lineGraph = {
  height: 80,
  background: "linear-gradient(90deg, #f97316, #fb923c)",
  borderRadius: 6,
};`
          }
      </style>
    </div>
  );
}